<template>
  <div class="login-page">
    <div>
      <div class="hkj-logo">
        <img src="../assets/images/logo.png" alt="">
      </div>
      <div class="weui-form">
        <div class="weui-form__bd">
          <div class="weui-form__control-area">
            <div class="weui-cells__group weui-cells__group_form" v-if="loginType === 'up'">
              <div class="weui-cells">
                <label for="js_input1" class="weui-cell weui-cell_active">
                  <div class="weui-cell__hd"><span class="weui-label">用户名</span></div>
                  <div class="weui-cell__bd">
                      <input id="js_input1" v-model="username" class="weui-input" placeholder="请输入账号">
                  </div>
                </label>
                <label for="js_input2" class="weui-cell weui-cell_active">
                  <div class="weui-cell__hd"><span class="weui-label">密&nbsp;&nbsp;码</span></div>
                  <div class="weui-cell__bd">
                      <input id="js_input2" type="password" v-model="password" class="weui-input" placeholder="请输入密码">
                  </div>
                </label>
                <label for="js_input3" class="weui-cell weui-cell_active">
                  <div class="weui-cell__hd"><span class="weui-label">记&nbsp;&nbsp;住</span></div>
                  <div class="weui-cell__bd">
                    <div class="rember">
                      <!-- checked -->
                      <img v-show="rember" src="../assets/images/checked.png">
                      <!-- not checked -->
                      <img v-show="!rember" src="../assets/images/not.png">
                    </div>
                    <input v-show="false" type="checkbox" id="js_input3" class="weui-checkbox" v-model="rember" />
                  </div>
                </label>
              </div>
              <div class="mt30 p30">
                <a href="javascript:" role="button" class="weui-btn weui-btn_primary bg-orange wd-auto" @click="handleLogin">登录</a>
              </div>
            </div>
            <div class="weui-cells__group weui-cells__group_form" v-if="loginType === 'ic'">
              <div class="weui-cells">
                <label for="js_input2" class="weui-cell weui-cell_active">
                  <div class="weui-cell__hd"><span class="weui-label">邀请码</span></div>
                  <div class="weui-cell__bd">
                      <input id="js_input2" type="text" v-model="inviteCode" class="weui-input" placeholder="邀请码">
                  </div>
                </label>
              </div>
              <div class="mt30 p30">
                <a href="javascript:" role="button" class="weui-btn weui-btn_primary bg-orange wd-auto" @click="handleLogin">登录</a>
              </div>
            </div>
            <div class="login-type p30">
              <a href="javascript:" @click="handleChangeLoginType()">
                {{ loginType==='ic' ? '账号密码登录' : '邀请码登录'}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from '@/services/user'
import { loginStore } from '@/store/index'
import { setToken } from '@/utils/token'
export default {
  name: 'LoginPage',
  components: {
  },
  data() {
    return {
      rember: false,
      username: '',
      password: '',
      showToast: false,
      loginMessages: '登录成功!',
      loginSuccess: false,
      loginType: 'ic',
      inviteCode: '' //默认邀请码登录
    }
  },
  created() {
    /** 如果点击了记住 */
    const { username, password, rember } = loginStore.get()
    if (rember) {
      // 取出系统中存储过的用户密码
      this.username = username
      this.password = password
      this.rember = true
    } else {
      this.username = ''
      this.password = ''
      this.rember = false
    }
  },
  methods: {
    processRemberInfo() {
      if (this.rember) {
        loginStore.set(this.username, this.password)
      } else {
        loginStore.clear()
      }
    },
    handleChangeLoginType() {
      if (this.loginType === 'ic') {
        this.loginType = 'up'
      } else {
        this.loginType = 'ic'
      }
    },
    /** 登录action */
    handleLogin() {
      this.processRemberInfo()
      const {username, password, rember} = this
      let postData = {}
      if (this.loginType === 'ic') {
        postData.invite_code = this.inviteCode
      } else {
          postData = {
          username,
          password,
          rember
        }
      }
      login(postData).then(res => {
        this.loginMessages = res.msg
        this.loginSuccess = true
        setToken( res.data.token )
        loginStore.setLoginType(res.data.loginType)
        this.$showToast({
          type: 'icon',
          toastSuccess: true,
          toastMessage: this.loginMessages,
          duration: 1000 
        })
        this.$router.push('/')
      }).catch(error => {
        this.loginSuccess = false
        this.loginMessages = error.msg
        this.$showToast({
          type: 'icon',
          toastSuccess: false,
          toastMessage: this.loginMessages,
          duration: 1000 
        })
        // utils.showToast(this)
      })
    }
  }
}
</script>
<style scoped>
.login-page{
  padding-top: var(--len100);
  background: white!important;
  border-left: 0.5px solid rgba(0,0,0,0.08);
  border-right: 0.5px solid rgba(0,0,0,0.08);
}
.hkj-logo{
  padding: 0 30px;
}
.hkj-logo img{
  width: 100%;
}
.weui-form {
  padding-top: 0px!important;
}
.p30{
  padding: 0 30px;
}
.login-type{
  /* padding: ; */
  margin-top: 40px;
  font-size: 12px;
  text-align: right;
}
.login-type a{
  color: #dddddd;
}
</style>
